import { Box, useTheme } from '@mui/material';
import React, { PropsWithChildren } from 'react';

import { headingCID } from '../Heading';

export const cardContentClassIdentifier = 'CID-CardContent';

const PADDING_BLOCK = 4;
const PADDING_INLINE = 7;
const ENDSPACING_BOTTOM_PADDING = 4;

interface CardContentProps {
  alignEnd?: boolean;
  centered?: boolean;
  endSpacing?: boolean;
  noStartSpacing?: boolean;
  style?: any;
}

/**
 * Wrapper component for Card contents
 * @returns {component} Component
 */
const CardContent: React.FC<PropsWithChildren<CardContentProps>> = ({
  alignEnd,
  centered,
  children,
  endSpacing,
  noStartSpacing,
  style,
}) => {
  const theme = useTheme();

  if (typeof children === 'undefined') {
    return <div />;
  }

  return (
    <Box
      className={cardContentClassIdentifier}
      data-testid="card-content"
      style={style}
      sx={{
        '& p a': {
          '&:hover': {
            textDecoration: 'underline',
          },
          fontWeight: 'normal',
          textDecoration: 'underline',
        },
        [`& .${headingCID}`]: {
          width: centered ? '100%' : undefined,
        },
        display: 'flex',
        flexDirection: 'column',
        alignSelf: alignEnd ? 'flex-end' : undefined,
        position: 'relative',
        wordBreak: 'break-word',
        textAlign: centered ? 'center' : undefined,
        padding: `${theme.spacing(PADDING_BLOCK)} ${theme.spacing(PADDING_INLINE)}`,
        paddingBottom: endSpacing ? theme.spacing(ENDSPACING_BOTTOM_PADDING) : 0,
        paddingTop: noStartSpacing ? 0 : undefined,
      }}
    >
      {children}
    </Box>
  );
};

export default CardContent;
